module.exports = __webpack_public_path__ + "static/img/hellocare.d8da1a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hellocare.png
// module id = Tr+4
// module chunks = 14